module.exports = __webpack_public_path__ + "img/Villa_Borna_38.d1ee0e87.jpg";